import React, {useEffect, useState, Fragment} from 'react'
import {useStateContext} from '../context/StateContext';
import {VisDiv} from '../components';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { isNonConformitySevere } from '../lib/utils';
import { HiOutlineQuestionMarkCircle } from "react-icons/hi2";




/**
 * 
 * #registersDevicesNonConformitiesModule
 * #nonConformities
 * #deviceNonConformities
 * A component that renders a list of non conformities.
 * @param {Array} nonConformityArray - the array of non conformities to render
 * @param {Function} filter - the filter function to apply to the array
 * @param {Array} visRules - the visibility rules for the component
 * @param {Function} onClick - the function to call when the component is clicked
 * @param {String} title - the title of the component
 * @param {String} titleColor - the color of the title
 * @returns {React.Component} - the component
 */
const ListaNonConformita = ({nonConformityArray, device, register, deviceTemplate, filter, visRules=[], onClick, title, titleColor}) => {
   
const {setCurrentNonConformity, nonConformities} = useStateContext();
const filteredArray = !Array.isArray(nonConformityArray) ? [] : nonConformityArray.filter?.(filter);



  return (
    <VisDiv className='new-device-container-top' style={{marginTop:"15px", marginBottom:"15px"}} rules={[...visRules, filteredArray?.length>0]}>
    <h2 style={{color: titleColor && titleColor}}>{title}</h2>

    {filteredArray.map?.((item, index)=>{
        const nonConformity = !Array.isArray(nonConformities) ? {} : nonConformities.find?.((x)=>x?._id==item?.nonConformity?._ref)
        const foundError = isThereNonConformityError({register, nonConformity, device})
        const testFunction = () => {
            console.log("lkasdklasjd test pin", {deviceTemplate, register, device, nonConformity, foundError})
        }
        
        const backgroundColor = () => {
            if(foundError?.hoverText) return "orange"
            if(item?.status=="ASSEGNATO") return "#FFBF00"
            if(item?.status=="COMPLETATO") return "#00FF00"
        } 
        const nNonConformities = item?.nNonConformities > 1 && ` X${item?.nNonConformities}`
        const onNonConformityClick = () => {
            //console.log("onclick non conf:", item)
            setCurrentNonConformity(item)
        }
        return(
            <div onClick={onNonConformityClick} key={index} className='nonConformity-pin-container' style={{marginTop:"15px", padding:"5px", backgroundColor: backgroundColor()}}> 

                <VisDiv rules={[isNonConformitySevere(item, nonConformities)]}><AiFillExclamationCircle fontSize={21} /></VisDiv>               
                <div onClick={onClick} className='vlfield-value-container' style={{display:'flex', textAlign:'left', marginRight:"5px"}}>
                    {nonConformity?.label} {nNonConformities}
                </div>
                <VisDiv rules={[foundError?.hoverText]}>
                    <QuestionMarkIcon color='red'  onClick={testFunction} hoverText={foundError?.hoverText}/>
                </VisDiv>
            </div>
        )
    }

    
    )}
</VisDiv>
  )
}

export default ListaNonConformita


export const QuestionMarkIcon = ({ hoverText, color, onClick = () => {} }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                //className="round-back-button"
                style={{
                    //backgroundColor: "white",
                    borderRadius: "50%",
                    padding: "5px",
                    cursor: "pointer",
                }}
                onClick={onClick}
            >
                <HiOutlineQuestionMarkCircle color={color} size={28} />
            </div>

            {isHovered && hoverText && (
                <div
                    style={{
                        position: "absolute",
                        bottom: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        marginBottom: "8px",
                        backgroundColor: "black",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        whiteSpace: "nowrap",
                        zIndex: 10,
                        pointerEvents: "none",
                    }}
                >
                    {hoverText}
                </div>
            )}
        </div>
    );
};

/**
 * #nonConformities
 * Determines if a non-conformity error is present based on the given non-conformity, register and device.
 * The function checks if the non-conformity has devices or device properties associated with it.
 * If the non-conformity has devices associated with it, it checks if the device is in the list.
 * If the non-conformity has device properties associated with it, it checks if the device has any of the properties.
 * If the non-conformity has registers associated with it, it checks if the register is in the list.
 * 
 * @param {object} nonConformity - The non-conformity object to check.
 * @param {object} register - The register object to check against.
 * @param {object} device - The device object to check against.
 * @returns {object} - An object with a hoverText property containing the error message. If no error is found, returns false.
 */
export  const isThereNonConformityError = ({nonConformity, register, device}) => {
            const nonConfDevices = nonConformity?.devices
            const isThereNonConfDevices = nonConfDevices?.length > 0 ? true : false
            const isInDevices = nonConfDevices?.some?.((x)=> device?.templateDevice?._ref == x?._ref) ? true : false
            const devicesExclude = nonConformity?.devicesExclude ? true : false

           
            const nonConfDeviceProperties = nonConformity?.deviceProperties
            const isThereNonConfDeviceProperties = nonConformity?.deviceProperties?.length > 0 ? true : false
            const isInNonConfDeviceProperties = nonConfDeviceProperties?.some?.((x)=> device?.fields?.some?.((y)=> y?.values?.some(z=>z?._id == x?._ref))) ? true : false
            const propertiesExclude = nonConformity?.propertiesExclude ? true : false
            //if(true) return {hoverText:"Test"}
            if(!nonConformity) return  {hoverText:"Non conformità non trovata"}
            if(nonConformity?.status == "ARCHIVIATO") return  {hoverText:"Modello non conformità archiviata"}
            
            if(isThereNonConfDevices && isThereNonConfDeviceProperties) {
                if(!isInDevices && !devicesExclude) return {hoverText:"Questa non conformità non ha questo dispositivo assegnato"}
                if(isInDevices && devicesExclude) return {hoverText:"Questa non conformità è esclusa dai dispositivi assegnati"}

                if(!isInNonConfDeviceProperties && !propertiesExclude) return {hoverText:"Questa non conformità non ha questa proprietà assegnata"}
                if(isInNonConfDeviceProperties && propertiesExclude) return {hoverText:"Questa non conformità è esclusa dalle proprietà assegnate"}

                return false
            }
            if(isThereNonConfDevices && !isThereNonConfDeviceProperties) {
                if(!isInDevices && !devicesExclude) return {hoverText:"Questa non conformità non ha questo dispositivo assegnato"}
                if(isInDevices && devicesExclude) return {hoverText:"Questa non conformità è esclusa dai dispositivi assegnati"}
                return false
            }
            if(isThereNonConfDeviceProperties && !isThereNonConfDevices) {
                if(!isInNonConfDeviceProperties && !propertiesExclude) return {hoverText:"Questa non conformità non ha questa proprietà assegnata"}
                if(isInNonConfDeviceProperties && propertiesExclude) return {hoverText:"Questa non conformità è esclusa dalle proprietà assegnate"}
                return false
            }
            if(!nonConformity?.registers) return false
            if(nonConformity?.registers?.length < 1) return false
            if(!nonConformity?.registers?.some?.((x)=> register?.template?._ref == x?._ref)) return {hoverText:"Questa non conformità non ha questa tipologia di registro assegnato"}
            return false
            }